module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rulerTitle":"Press and pull to add new ruler","rulerText":"add ruler"},"ru":{"rulerTitle":"Зажмите и потяните, чтобы добавить новую направляющую","rulerText":"добавить направляющую"}}')
  delete Component.options._Ctor
}
